import { cloneDeep } from 'lodash';

/* returns a custom object after removing idTokens/access_token
 * @param  {obj} response - response from isRecognized API
 * @return {obj} customResponse - return customResponse
*/
const getCustomResponse = response => {
  const customResponse = cloneDeep(response);
  if (customResponse?.customData) {
    delete customResponse?.customData?.data?.access_token;
  }
  if (customResponse?.idTokens) {
    delete customResponse?.idTokens;
  }
  return customResponse;
};

export default getCustomResponse;
